import { useState, useEffect } from './h.js'

/**
 * Whether this account may talk to Anya: true, false, or null while unknown.
 * Asked when her chat opens and every minute after, so access granted in the
 * console shows up without reopening anything.
 */
export function useAssistantAccess (store, active) {
  const [allowed, setAllowed] = useState(null)
  useEffect(() => {
    if (!active || !store.client.assistant) { setAllowed(null); return }
    let alive = true
    const check = () => store.client.assistant.access({ refresh: true })
      .then((answer) => { if (alive) setAllowed(answer) })
      .catch(() => {})
    check()
    const timer = setInterval(check, 60000)
    return () => { alive = false; clearInterval(timer) }
  }, [store, active])
  return allowed
}

/**
 * The bot card of an account, or null for a person.
 *
 * Follows contact changes: in a chat with a bot the card usually arrives over
 * the chat itself a second after it opens (see room.announceProfile), and the
 * command menu and the "Start" button appear as soon as it does.
 */
export function useBotCard (store, account) {
  const [card, setCard] = useState(null)
  useEffect(() => {
    setCard(null)
    if (!account) return
    let alive = true
    const load = (ask) => store.client.botCard(account, { ask })
      .then((found) => { if (alive) setCard(found) })
      .catch(() => {})
    load(true)
    const off = store.client.on('contacts-changed', () => load(false))
    return () => { alive = false; off() }
  }, [store, account])
  return card
}
